// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"Loader_loaderContainer__3Y8-2","ldio":"Loader_ldio__2TX87","smallLoader":"Loader_smallLoader__3WMtG","loadingio":"Loader_loadingio__1vvHX"};